

/**
 * @name ExpireOperatorModalController
 * @description Function to remove operators from a shop
 * @param {unknown} $uibModalInstance UI Bootstrap image modal instance
 * @param {unknown} Association The association service
 * @param {unknown} operator Resolved operator from the shop operators controller
 */
function ExpireOperatorModalController(
  $uibModalInstance,
  Association,
  operator
) {
  let vm = this;
  vm.operator = operator;

  vm.expireOperator = function(operator) {
    Association.expire(operator.association).then(function() {
      $uibModalInstance.close();
    });
  };

  vm.cancel = function() {
    $uibModalInstance.dismiss();
  };
}

angular
.module('inkfinder')
.controller('ExpireOperatorModalController', ExpireOperatorModalController);



// WEBPACK FOOTER //
// ./components/shop/operators/expire/expire-operator-modal.controller.js